import "./resizableSplit.scss";
import type React from "react";
import {Separator} from "react-resizable-panels";

/** Class for the Group around a SplitSeparator: stops iframes taking the pointer while it is dragged. */
export const RESIZABLE_SPLIT_CLASS = "resizable-split";

/**
 * The 1px line between two react-resizable-panels Panels, 3px while hovered or dragged. Its colours
 * come from `--split-line` and `--split-line-active` set on an ancestor.
 */
export const SplitSeparator: React.FC<{id: string}> = ({id}) => (
    <Separator id={id} className="resizable-split-separator"/>
);
